import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { Booking } from "@/components/site/Booking";
import { Hub } from "@/components/site/Hub";
import { CtaBand, Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="bg-[#050505] text-white overflow-x-clip" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <About />
        <Booking />
        <Hub />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}
